import { create } from 'zustand';

interface UIState {
  mobileNavOpen: boolean;
  cartDrawerOpen: boolean;
  openMobileNav: () => void;
  closeMobileNav: () => void;
  toggleCartDrawer: () => void;
  openCartDrawer: () => void;
  closeCartDrawer: () => void;
}

export const useUIStore = create<UIState>(set => ({
  mobileNavOpen: false,
  cartDrawerOpen: false,
  openMobileNav: () => set({ mobileNavOpen: true }),
  closeMobileNav: () => set({ mobileNavOpen: false }),
  toggleCartDrawer: () => set(s => ({ cartDrawerOpen: !s.cartDrawerOpen })),
  openCartDrawer: () => set({ cartDrawerOpen: true }),
  closeCartDrawer: () => set({ cartDrawerOpen: false }),
}));
